import { request } from "../../api/api"

export const getPlants = () => {
    return request.get('/packing/getPlants')
    // return console.log("service")
}
export const getProducts = (id) => {
    return request.get(`/packing/getProducts/?plant_id=${id}`)
}
export const getSizes = (id) => {
    return request.get(`/packing/getSizes/?product_id=${id}`)
}
export const getSizesExtruder = () => {
    return request.get('/packing/getSizes/')
}
export const getPackNo = (id) => {
    return request.get(`/packing/getPackNo/?plant_id=${id}`)
}
